import { render, staticRenderFns } from "./DriverBlackListUpload.vue?vue&type=template&id=056d4b81&scoped=true"
import script from "./DriverBlackListUpload.vue?vue&type=script&lang=js"
export * from "./DriverBlackListUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056d4b81",
  null
  
)

export default component.exports